import { Outlet, Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, IconButton, Drawer, List, ListItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import { Dashboard as DashboardIcon, Apps, ConfirmationNumber, Storage, People, Settings, Security, Assessment, DarkMode, LightMode } from '@mui/icons-material';
import { useThemeStore } from '../stores/themeStore';

const drawerWidth = 240;

export function Layout() {
    const location = useLocation();
    const { darkMode, toggleDarkMode } = useThemeStore();
    const theme = useTheme();

    const menuItems = [
        { path: '/dashboard', icon: <DashboardIcon />, label: 'Dashboard' },
        { path: '/products', icon: <Apps />, label: 'Products' },
        { path: '/licenses', icon: <ConfirmationNumber />, label: 'Licenses' },
        { path: '/servers', icon: <Storage />, label: 'Servers' },
        { path: '/customers', icon: <People />, label: 'Customers' },
        { path: '/logs', icon: <Assessment />, label: 'Logs' },
    ];

    return (
        <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900">
            <AppBar position="fixed" className="z-10">
                <Toolbar>
                    <Typography variant="h6" component="div" className="flex-grow">
                        MIGHTYSCAPE License Server
                    </Typography>
                    <IconButton onClick={toggleDarkMode} color="inherit">
                        {darkMode ? <LightMode /> : <DarkMode />}
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Drawer
                variant="permanent"
                className="w-60"
                PaperProps={{
                    className: 'w-60 bg-white dark:bg-gray-800',
                }}
            >
                <Toolbar />
                <div className="overflow-auto">
                    <List>
                        {menuItems.map((item) => (
                            <ListItem
                                button
                                key={item.path}
                                component={Link}
                                to={item.path}
                                selected={location.pathname === item.path}
                                className="text-gray-700 dark:text-gray-300"
                            >
                                <ListItemIcon className={location.pathname === item.path ? 'text-primary-600' : 'text-gray-500'}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.label} />
                            </ListItem>
                        ))}
                    </List>
                </div>
            </Drawer>

            <main className="flex-1 p-6 pt-20">
                <Outlet />
            </main>
        </div>
    );
}